import DetailLayout from "./DetailLayout";

export default DetailLayout